import React from 'react'

import { getAbsenteeismSummaryText } from './constants'

export function PercentageBadge({ percent, badgeClassName, numClassName, pctClassName }) {
  return (
    <div className={badgeClassName}>
      <span className={numClassName}>{percent}</span>
      <span className={pctClassName}>%</span>
    </div>
  )
}

export function SeverityChip({ label, icon: Icon, className, iconClassName }) {
  return (
    <span className={className}>
      {Icon && <Icon className={iconClassName} fontSize="inherit" />}
      {label}
    </span>
  )
}

export function SummaryText({ absentTurns, totalTurns, className }) {
  const summaryText = getAbsenteeismSummaryText(absentTurns, totalTurns)
  return <span className={className}>{summaryText}</span>
}

export function ProgressBar({ percent, trackClassName, fillClassName }) {
  return (
    <div className={trackClassName}>
      <div className={fillClassName} style={{ width: `${percent}%` }} />
    </div>
  )
}
